import { mount } from "svelte";
import SearchSignpostBanner from "../elements/Banners/SearchSignpost/SearchSignpostBanner.svelte";

export const bindSearchSignpostBanner = () => {
  const target = document.getElementById("search-signpost-banner");
  if (target) {
    mount(SearchSignpostBanner, { target });
  }
};
